


export default class photoGallery {
    constructor () {
        $('[data-fancybox="images"]').fancybox({
            afterLoad : function(instance, current) {
                current.$image.attr('alt', current.opts.$orig.find('img').attr('alt').replace('Click to open the photo gallery', ''));
                current.$image.attr('tabindex', '0');

                $('.fancybox-button--close').attr('aria-label', 'Close photo gallery');
                $('.fancybox-button--arrow_right').attr('aria-label', 'Next Photo');
                $('.fancybox-button--arrow_left').attr('aria-label', 'Previous Photo');
            }
        });
    }
}
